<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="d-flex justify-center mb-2 mt-2">
          <v-text-field
            label="Search"
            outlined
            dense
            class="ml-5"
            v-model="userSearchBox"
          >
          </v-text-field>
          <v-btn color="primary" class="ml-2 mr-5" @click="userSearchClick">
            Search
          </v-btn>
        </div>
        <p v-if="userSearch.length > 0">
          Searching for: "{{ userSearch }}"
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel v-for="(item, i) in sortedUsers" :key="i">
            <v-expansion-panel-header>
              <div class="d-flex align-center flex-wrap" style="gap: 12px">
                <v-chip
                  small
                  :color="item.Status === 'active' ? 'green' : 'orange'"
                  text-color="white"
                >
                  {{ item.Status }}
                </v-chip>
                <span>{{ item.Email }}</span>
                <v-chip v-if="item.IsPro" small color="blue" text-color="white">
                  Pro
                </v-chip>
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="grey--text text-body-2">
                      {{ $utils.relativeTimeFromTs(item.DateCreated) }}
                    </span>
                  </template>
                  <span>{{ $utils.timeFromTs(item.DateCreated) }}</span>
                </v-tooltip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="6">
                  <strong>Id:</strong>
                  {{ item.Id }}
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-avatar size="32" class="mr-2">
                    <v-img v-if="item.Avatar" :src="item.Avatar"></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                  <span>{{ item.Phone || "No phone on file" }}</span>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong>Roles:</strong>
                  <span v-if="!item.Roles || item.Roles.length === 0">—</span>
                  <v-chip
                    small
                    v-for="role in item.Roles"
                    :key="role"
                    class="ml-1 mb-1"
                  >
                    {{ role }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6">
                  <strong>Evaluations today:</strong>
                  <span v-if="todayEvalCount(item) !== null">
                    {{ todayEvalCount(item) }}
                  </span>
                  <span v-else class="grey--text">None recorded</span>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn plain @click="loadMoreUsers" v-if="usersLoaded">
            Load more
          </v-btn>
          <v-spacer></v-spacer>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!usersLoaded">
      <v-col>
        <div class="d-flex justify-center">
          <v-progress-circular
            class="mt-10 mb-10"
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      usersLoaded: false,
      usersLastEmail: "",
      userSearch: "",
      userSearchBox: "",
      btnUsersNextDisabled: false,
      btnUsersPrevDisabled: true,
    };
  },
  computed: {
    sortedUsers() {
      return [...this.users].sort((a, b) => b.DateCreated - a.DateCreated);
    },
  },
  methods: {
    todayEvalCount(item) {
      if (!item || !item.EvalCounter) {
        return null;
      }
      var parts = item.EvalCounter.split(":");
      if (parts.length !== 2) {
        return null;
      }
      var now = new Date();
      var todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      if (parts[0] !== todayStr) {
        return null;
      }
      return parts[1];
    },
    async loadMoreUsers() {
      this.usersLoaded = false;
      this.getUsers();
      this.usersLoaded = true;
    },
    getUsers(searchText) {
      this.usersLoaded = false;
      var dusi = this.$store.getters.getDusi;
      if (searchText) {
        this.userSearch = searchText;
      }
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/admin/getUsers",
          {
            userSearch: this.userSearch,
            lastEmail: this.usersLastEmail,
            dusi: dusi,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            this.users.push(...response.data);
            if (this.users.length > 0) {
              this.usersLastEmail = this.users[this.users.length - 1].Email;
            } else {
              this.usersLastEmail = "";
            }
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
        })
        .finally(() => {
          this.usersLoaded = true;
        });
    },
    userSearchClick() {
      if (this.userSearchBox.length > 0) {
        this.usersLastEmail = "";
        this.users = [];
        this.getUsers(this.userSearchBox);
      }
    },
  },
};
</script>
